import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const YoKyujoKbn = props => {
  return <Dropdown.Static kubunKey='yo_kyujo_kbn' {...props} />
}
